import { useState } from "react"
import { DateRangePicker } from "../../shared/dateRangePicker"
import { SearchSelect } from "../../shared/searchSelect"
import { SearchFiltersModal } from "../../shared/searchFiltersModal"
import stringHelpers from "../../../utilities/stringHelpers"
import { toDateString } from "../../../utilities/dateUtilities"
import Enums from "../../../utilities/enum"
import { TagSelector } from "../../shared/tagSelector"
import appliedFiltersUtilities from "../../../utilities/appliedFiltersUtilities"
import arrayUtilities from "../../../utilities/arrayUtilities"

export const ClientLandingFiltersModal = ({
    showModal,
    handleClose,
    handleConfirm,
    initialFilterStart,
    initialFilterEnd,
    initialFilterPeriodType,
    initialSelectedTags = [],
    initialAppliedFilters,
    tags = []
}) => {
    const [filterStart, setFilterStart] = useState(initialFilterStart)
    const [filterEnd, setFilterEnd] = useState(initialFilterEnd)
    const [filterPeriodType, setFilterPeriodType] = useState(initialFilterPeriodType)
    const [selectedTags, setSelectedTags] = useState(initialSelectedTags)
    const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

    const clearLocalFilters = () => {
        setFilterStart(null)
        setFilterEnd(null)
        setFilterPeriodType(0)
        setSelectedTags([])
        setAppliedFilters(null)
    }

    const handleTagsChange = tagSelections => {
        setSelectedTags(tagSelections)
        setAppliedFilters(prevState => appliedFiltersUtilities.applyMultiSelection(prevState, "Tags", tagSelections, tags))
    }

    return (
        <SearchFiltersModal
            title="Filter Results"
            handleClose={ handleClose }
            handleConfirm={ () => handleConfirm({ filterStart, filterEnd, filterPeriodType, selectedTags, appliedFilters }) }
            showModal={ showModal }
            key="client-landing-filters-modal"
            handleReset={ clearLocalFilters }
        >
            <div className="w-100">
                <div className="mb-2">
                    <label className="m-0 mr-2 mb-1 nowrap">Date Range</label>
                    <DateRangePicker
                        fromDate={ filterStart }
                        toDate={ filterEnd }
                        setDateRange={ (firstDate, lastDate, presetLabel) => {
                            const isFirstDateEmpty = firstDate === null || firstDate === ""
                            const isLastDateEmpty = lastDate === null || lastDate === ""
                            setFilterStart(isFirstDateEmpty ? null : firstDate)
                            setFilterEnd(isLastDateEmpty ? null : lastDate)
                            if (!stringHelpers.isNullOrEmpty(presetLabel)) {
                                setAppliedFilters(prevState => {
                                    const updatedFilters = { ...prevState }
                                    delete updatedFilters.From
                                    delete updatedFilters.To
                                    updatedFilters["Date Range"] = presetLabel
                                    return updatedFilters
                                })
                            }
                            else {
                                setAppliedFilters(prevState => {
                                    const updatedFilters = { ...prevState }
                                    if (!isFirstDateEmpty && !isLastDateEmpty) {
                                        delete updatedFilters.From
                                        delete updatedFilters.To
                                        updatedFilters["Date Range"] = `${ toDateString(new Date(firstDate)) } - ${ toDateString(new Date(lastDate)) }`
                                    } else {
                                        if (!isFirstDateEmpty) {
                                            updatedFilters.From = toDateString(new Date(firstDate))
                                        } else {
                                            delete updatedFilters.From
                                        }
                                        if (!isLastDateEmpty) {
                                            updatedFilters.To = toDateString(new Date(lastDate))
                                        } else {
                                            delete updatedFilters.To
                                        }
                                        delete updatedFilters["Date Range"]
                                    }
                                    return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
                                })
                            }
                        } }
                        showClearOption
                        hideLabel
                        fullWidth
                        dropdownPositionRight
                    />
                </div>

                <div className="d-flex flex-column mb-2">
                    <label className="m-0 mr-2 mb-1 nowrap">Filter by Period Type</label>
                    <SearchSelect
                        defaultLabel="All"
                        width="100%"
                        options={ Object.entries(Enums.FilterPeriodType).map(([key, value]) => ({ value: key, label: value })) }
                        onSelect={ value => {
                            setFilterPeriodType(Number(value))
                            setAppliedFilters(prevState => {
                                const updatedFilters = { ...prevState }
                                if (value === "0") {
                                    delete updatedFilters["Period Type"]
                                } else {
                                    updatedFilters["Period Type"] = Enums.FilterPeriodType[value]
                                }
                                return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
                            })
                        } }
                        selected={ String(filterPeriodType) }
                    />
                </div>

                { !arrayUtilities.isNullOrEmpty(tags) && <div className="d-flex flex-column mb-2">
                    <div className="d-flex align-items-center justify-content-between">
                        <label className="m-0 mr-2 mb-1 nowrap">Tags</label>
                        <button onClick={ () => handleTagsChange([]) } className="btn btn-none m-0 p-0 fs--1 mb-1" type="button">Clear tags</button>
                    </div>
                    <TagSelector
                        onChange={ handleTagsChange }
                        selectedTags={ selectedTags }
                        tags={ tags }
                    />
                </div> }
            </div>
        </SearchFiltersModal>
    )
}
